import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { findDOMNode } from 'react-dom';
import Footer from 'routes/Home/components/Footer';
import NewHeader from 'routes/Home/components/Header';
import Header from './Header';
import 'styles/layout.scss';
class Layout extends React.Component {
    constructor() {
        super(...arguments);
        this._renderHeader = () => (this.props.newHeader ? this._newHeader() : this._oldHeader());
        this._oldHeader = () => (_jsx("div", { className: "layout__header", ref: "header", style: { flexShrink: 0 }, children: _jsx(Header, Object.assign({}, this.props.headerOptions)) }));
        this._newHeader = () => _jsx(NewHeader, { embed: true, logoAsset: this.props.logoAsset });
    }
    componentDidMount() {
        this._mount();
    }
    componentWillUnmount() {
        this._unmount();
    }
    _mount() {
        if (this.refs.header) {
            this._sticky = require('stickyfill')();
            // deprecated
            // eslint-disable-next-line react/no-find-dom-node
            this._sticky.add(findDOMNode(this.refs.header));
        }
        else {
            this._unmount();
        }
    }
    _unmount() {
        if (this._sticky) {
            this._sticky.kill();
            delete this._sticky;
        }
    }
    render() {
        return (_jsxs("section", { className: classnames(this.props.className, 'layout'), children: [_jsxs("div", { className: "layout__container", children: [this.props.header ? this._renderHeader() : null, _jsx("section", { className: "layout__content", children: this.props.children })] }), _jsx("div", { className: "layout__footer", children: _jsx(Footer, {}) })] }));
    }
}
Layout.propTypes = {
    header: PropTypes.bool,
};
Layout.defaultProps = {
    header: true,
    headerOptions: {},
};
export default Layout;
function component(type) {
    class LayoutComponent extends React.Component {
        render() {
            return (_jsx("div", Object.assign({}, this.props, { className: classnames(this.props.className, `layout-${type}`), children: this.props.children })));
        }
    }
    return LayoutComponent;
}
Layout.Container = component('container');
Layout.Content = component('content');
